// components/ThemeToggle.jsx
import React, { useState, useEffect } from 'react';
export default function ThemeToggle() {
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('theme') || 'dark';
    });

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
    };
    return (
        <button onClick={toggleTheme} className="btn">
            {theme === 'dark' ?
                <span className="material-symbols-outlined">sunny</span> :
                <span className="material-symbols-outlined">mode_night</span>}
        </button>
    );
};